<template>
  <div class="form-section">
    <div class="columned two-column">
      <div
        class="form-group vanilla"
        :class="{ 'has-input-error': errors.first_name }"
      >
        <label :for="`profile-first-name_${this._uid}`"
          >First name <span class="required">*</span></label
        >
        <input
          :id="`profile-first-name_${this._uid}`"
          type="text"
          name="profile-first-name"
          v-model="data.first_name"
          required
        />
        <input-error v-if="errors.first_name">
          {{ errors.first_name[0] }}
        </input-error>
      </div>
      <div
        class="form-group vanilla"
        :class="{ 'has-input-error': errors.last_name }"
      >
        <label :for="`profile-last-name_${this._uid}`"
          >Last name <span class="required">*</span></label
        >
        <input
          :id="`profile-last-name_${this._uid}`"
          type="text"
          name="last_name"
          v-model="data.last_name"
          required
        />
        <input-error v-if="errors.last_name">
          {{ errors.last_name[0] }}
        </input-error>
      </div>
      <div
        class="form-group vanilla double"
        :class="{ 'has-input-error': errors.email }"
      >
        <label :for="`profile-email_${this._uid}`"
          >Email <span class="required">*</span></label
        >
        <input
          :id="`profile-email_${this._uid}`"
          type="email"
          name="email"
          v-model="data.email"
          required
        />
        <input-error v-if="errors.email">
          {{ errors.email[0] }}
        </input-error>
      </div>
      <div
        class="form-group vanilla"
        :class="{ 'has-input-error': errors.job_title }"
        v-if="$store.getters['user/isHirer']"
      >
        <label :for="`profile-job-title_${this._uid}`"
          >Job title <span class="required">*</span></label
        >
        <input
          :id="`profile-job-title_${this._uid}`"
          type="text"
          name="job_title"
          v-model="data.job_title"
          required
        />
        <input-error v-if="errors.job_title">
          {{ errors.job_title[0] }}
        </input-error>
      </div>
      <div
        class="form-group vanilla"
        :class="{ 'has-input-error': errors.phone }"
      >
        <label :for="`profile-phone_${this._uid}`">Primary contact phone<span class="required">*</span></label>
        <input
          :id="`profile-phone_${this._uid}`"
          type="text"
          name="phone"
          v-model="data.phone"
          required
        />
        <input-error v-if="errors.phone">
          {{ errors.phone[0] }}
        </input-error>
      </div>
    </div>
    <div class="columned two-column">
      <div
        class="form-group vanilla"
        :class="{ 'has-input-error': errors.dob }"
      >
        <label :for="`profile-dob-day_${this._uid}`">Date of Birth </label>
        <date-select-group
          :id="`profile-dob-day_${this._uid}`"
          v-model="data.dob"
          @input="delete errors.dob"
        ></date-select-group>
        <input-error v-if="errors.dob">
          {{ errors.dob[0] }}
        </input-error>
      </div>
      <div
        class="form-group vanilla"
        :class="{ 'has-input-error': errors.gender }"
      >
        <label :for="`profile-gender_${this._uid}`">Gender</label>
        <select-wrapper
          :id="`profile-gender_${this._uid}`"
          :options="genderOptions"
          v-model="data.gender"
        ></select-wrapper>
        <input-error v-if="errors.gender">
          {{ errors.gender[0] }}
        </input-error>
      </div>
    </div>
  </div>
</template>

<script>
import SharedFields from "./SharedFields";

const fields = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  job_title: "",
  dob: "",
  gender: "",
};

export { fields };

export default {
  extends: SharedFields,
};
</script>
